import { useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../lib/http';
import { useAbortableTask } from './useAbortableTask';

const EMPTY_FORM = { full_name: '', firm_name: '', email: '', phone: '' };
export function useDemoRequest(copy) {
  const [form, setForm] = useState(EMPTY_FORM), [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false), [error, setError] = useState('');
  const inFlight = useRef(false), task = useAbortableTask();
  const update = field => event => {
    const value = event.target.value;
    setForm(previous => ({ ...previous, [field]: value }));
  };
  const reset = () => { setForm(EMPTY_FORM); setSubmitted(false); setError(''); };
  const submit = async event => {
    event.preventDefault();
    if (inFlight.current) return;
    if (!form.full_name.trim() || !form.email.trim()) { toast.error(copy.toastValidation); return; }
    const operation = task.start(); inFlight.current = true; setSubmitting(true); setError('');
    try {
      await axios.post(`${API}/demo-requests`, form, { signal: operation.signal });
      if (task.isCurrent(operation)) { setSubmitted(true); toast.success(copy.toastSuccess); }
    } catch {
      if (task.isCurrent(operation)) { setError(copy.toastError); toast.error(copy.toastError); }
    } finally {
      if (task.isCurrent(operation)) { setSubmitting(false); inFlight.current = false; }
    }
  };
  return { form, submitting, submitted, error, update, reset, submit };
}